var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2717_27476",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H30V30.5H0V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2717_27476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1265 13.0191C20.7622 14.2009 23.3748 15.5005 25.5469 15.5005C25.5469 6.87402 20.2734 4.89502 15 4.89502C9.72656 4.89502 4.45312 6.85873 4.45312 15.5005C6.62525 15.5005 9.23783 14.2009 10.8735 13.0191",
    stroke: "#F2EADF",
    strokeWidth: 1.75781,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8315 15.2727C24.4136 17.8333 24.0109 19.9468 23.7892 20.774C22.8926 20.5338 18.5972 19.8692 16.6128 15.9872",
    stroke: "#F2EADF",
    strokeWidth: 1.75781,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9204 23.3378C17.7765 25.1119 19.2377 25.5344 21.1521 26.0474C21.7029 23.9917 22.141 22.6718 21.4747 20.1138",
    stroke: "#F2EADF",
    strokeWidth: 1.75781,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3826 15.9986C11.3776 19.888 7.13232 20.5271 6.21117 20.7739C5.99847 19.9801 5.58398 17.8484 6.16898 15.2726",
    stroke: "#F2EADF",
    strokeWidth: 1.75781,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0784 23.3369C12.2255 25.1212 10.6497 25.5644 8.84743 26.0474C8.27726 23.9193 7.86505 22.6469 8.52353 20.1186",
    stroke: "#F2EADF",
    strokeWidth: 1.75781,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3945 10.2271C19.3945 14.6216 15 17.2583 15 17.2583C15 17.2583 10.6055 14.6216 10.6055 10.2271C10.6055 5.83252 12.573 4.89502 15 4.89502C17.427 4.89502 19.3945 5.83252 19.3945 10.2271Z",
    stroke: "#F2EADF",
    strokeWidth: 1.75781,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4219 18.3187C18.4219 20.774 15.9801 23.3536 15 24.2897C14.0203 23.3539 11.5786 20.774 11.5786 18.3217",
    stroke: "#F2EADF",
    strokeWidth: 1.75781,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0597 24.9359C18.0597 27.8052 15.8098 28.8481 15 29.6216C14.1898 28.8476 11.939 27.8052 11.939 24.932",
    stroke: "#F2EADF",
    strokeWidth: 1.75781,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7578 1.37939C15.787 1.37939 15 2.16637 15 3.13721V4.89502",
    stroke: "#F2EADF",
    strokeWidth: 1.75781,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCraft);
export default __webpack_public_path__ + "static/media/craft.f95b9a4035430cef08adc7b17eaf397a.svg";
export { ForwardRef as ReactComponent };